import React from 'react'

export default function ruLocaleDate(
  date: string | number | Date,
  options: Intl.DateTimeFormatOptions
) {
  return new Date(date).toLocaleDateString('ru-Ru', options)
}
